import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { cn } from '../lib/utils';
const faqs = [{
  q: '¿Esto reemplaza al médico?',
  a: 'No. Te da alivio responsable para lo leve y criterio para saber cuándo consultar. El objetivo es que sepas actuar en casa cuando es seguro, y correr al médico cuando es necesario.'
}, {
  q: '¿Necesito plantas raras?',
  a: 'No. Está diseñado con ingredientes accesibles (súper/farmacia) y sustituciones. No te vamos a pedir raíz de mandrágora importada.'
}, {
  q: '¿Sirve si nunca usé remedios naturales?',
  a: "Sí, porque no se basa en 'saber plantas', se basa en pasos simples y límites claros. Es un manual de instrucciones, no un curso de botánica."
}, {
  q: '¿Lo puedo usar con niños?',
  a: 'Incluye versión ultra conservadora y advertencias específicas. Ante dudas, el Semáforo Amarillo te indicará consultar. La seguridad es la prioridad #1.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Es un producto 100% digital. Te llega un email inmediatamente después de la compra con el link de descarga.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section background="cream" data-id="element-46">
      <h2 className="text-3xl md:text-4xl text-center mb-8" data-id="element-47">
        Preguntas Frecuentes
      </h2>
      <div className="max-w-2xl mx-auto space-y-3" data-id="element-48">
        {faqs.map((faq, i) => <div key={i} className="bg-white rounded-lg border border-[#1B4332]/10 overflow-hidden" data-id="element-49">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-50">
              <span className="font-bold text-[#1B4332] text-lg" data-id="element-51">{faq.q}</span>
              <ChevronDown className={cn('w-5 h-5 text-[#C9963A] transition-transform duration-300', openIndex === i ? 'rotate-180' : '')} data-id="element-52" />
            </button>
            <AnimatePresence data-id="element-53">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-54">
                  <div className="px-5 pb-5 text-gray-600 leading-relaxed" data-id="element-55">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}